import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ButtonWrapper from "../../components/ButtonWrapper";
import { useDispatch, useSelector } from "react-redux";
import postQrInitManualTransaction from "../../redux/actions/postQrInitManual";
import { useNavigate, useParams } from "react-router-dom";
import SpinerIndicator from "../../components/SpinerIndicator";
import MainWrapper from "../../components/MainWrapper";

const CardWrapper = styled.div`
  height: auto;
  margin-bottom: 20px;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 30%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;

  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
`;

const OnePayTransactionInfoCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const [loadingNext, setLoadingNext] = useState(false);
  const [hasDispatched, setHasDispatched] = useState(false);

  const verifyManualTransactoinState = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { data } = verifyManualTransactoinState;

  useEffect(() => {
    if (data && !hasDispatched) {
      setHasDispatched(true);
      autoDispatch();
    }
  }, [data]);

  const autoDispatch = async () => {
    setLoadingNext(true);

    let qrManualTransactionParams = {
      qrCodeTransactionId: data.trxRef,
      type: "auto",
      amount: data.amount,
      sessionId: data.sessionToken,
      userId: data.merchantId,
    };

    try {
      await dispatch(
        postQrInitManualTransaction(
          qrManualTransactionParams,
          navigate,
          params.id,
          "thb"
        )
      );
    } finally {
      setLoadingNext(false);
    }
  };

  return (
    <MainWrapper>
      <SpinerIndicator fontSize="50px" color="#fff" text="Processing..." />
    </MainWrapper>
  );
};

export default OnePayTransactionInfoCard;
